export const banner = {
  cover: 'https://img.alicdn.com/tfs/TB12ddTKhnaK1RjSZFBXXcW7VXa-1920-627.jpg',
  mcover: 'https://gw.alicdn.com/tfs/TB10w46M9zqK1RjSZPxXXc4tVXa-750-320.png',
  title: '产品和服务',
};

const product1 = {
  title: '全民健康信息平台',
  img: 'https://img.alicdn.com/tfs/TB1dxtKy.T1gK0jSZFhXXaAtVXa-2222-1482.png',
  // path: '/service?post=3',
  icon: 'https://gw.alicdn.com/tfs/TB1gy8vN6DpK1RjSZFrXXa78VXa-76-58.png',
  class: 'icon-ecard',
  tab: 'card',
  desc:
    '根据国家“46312”建设总体框架，统筹区域信息化建设，统一数据标准，完善管理制度，联通各个医疗机构，实现各级应用系统的数据交换、资源共享、互联互通和业务协同，提升区域卫生服务能力和综合管理能力。',
};
const product2 = {
  title: '智慧服务',
  img: 'https://img.alicdn.com/tfs/TB1c_l7yNz1gK0jSZSgXXavwpXa-1920-1080.jpg',
  // path: '/service?post=3',
  icon: 'https://gw.alicdn.com/tfs/TB1gy8vN6DpK1RjSZFrXXa78VXa-76-58.png',
  class: 'icon-ecard',
  tab: 'card',
  desc:
    '提供健康管理、医后付、智能导诊、在线诊疗等能力，覆盖诊前、诊中、诊后的就医全流程，提升医院智慧服务水平。',
  content: [
    {
      img: 'https://img.alicdn.com/tfs/TB1UpRcKkvoK1RjSZPfXXXPKFXa-548-378.png',
    },
    {
      text:
        '居民健康卡是国家卫生健康委员会统一规划实施的统一标准的“就诊卡”，可实现居民全程健康管理，提升居民健康的统一服务水平。当前智能卡应用正处在从“线下实体”向“线上虚拟”加速转型过程中，推进安全、可信的电子健康卡应用建设，实现线上线下一体化的身份认证服务，对于促进服务流程优化，保障线上应用安全，降低发卡用卡成本，实现居民健康卡应用广泛覆盖等具有十分重要的意义。',
    },
    {
      text:
        '电子健康卡具备就诊卡的所有功能。患者通过展示二维码给收费窗口、自助机、诊间、药房窗口和检验窗口来实现就诊全流程。与传统就诊卡相比，电子健康卡更方便用户携带(只需要携带手机即可)、安全性更高(动态二维码)、操作更方便。',
    },
  ],
};
const product3 = {
  title: '智慧管理',
  img: 'https://img.alicdn.com/tfs/TB1qGBKyYr1gK0jSZFDXXb9yVXa-2836-1712.png',
  // path: '/service?post=3',
  icon: 'https://gw.alicdn.com/tfs/TB1gy8vN6DpK1RjSZFrXXa78VXa-76-58.png',
  class: 'icon-ecard',
  tab: 'card',
  desc:
    '提供全面的医院运营、管理、医疗质量的统计分析指标，满足监管、运营能力提升，为医院管理、决策提供及时有效的数据支持。',
};
const product4 = {
  title: '智慧临床',
  img: 'https://img.alicdn.com/tfs/TB1h5xNyYj1gK0jSZFOXXc7GpXa-2264-1482.png',
  // path: '/service?post=3',
  icon: 'https://gw.alicdn.com/tfs/TB1gy8vN6DpK1RjSZFrXXa78VXa-76-58.png',
  class: 'icon-ecard',
  tab: 'card',
  desc:
    '提供CDSS、患者360全息视图、闭环管理、eMAR、病历质控等全面的临床应用，以提升医院的医疗质量、提高医护人员的工作效率的同时保障患者安全，在提升患者就医体验的同时增加了医院的品牌效应。',
};
const product5 = {
  title: '健康门户',
  img: 'https://img.alicdn.com/tfs/TB1_EN_yO_1gK0jSZFqXXcpaXXa-960-540.jpg',
  // path: '/service?post=2',
  icon: 'https://gw.alicdn.com/tfs/TB100RON4jaK1RjSZFAXXbdLFXa-72-62.png',
  class: 'icon-data',
  tab: 'data',
  desc:
    '基于统一入口的优势，搭建医院统一的医疗健康门户，可为患者提供预约诊疗、信息查询、在线缴费、便民共享等服务。',
  content: [
    {
      img: 'https://img.alicdn.com/tfs/TB1MS0LJbvpK1RjSZFqXXcXUVXa-548-378.png',
    },
    {
      isTitle: true,
      text: '大数据存储与安全',
    },
    {
      text:
        '构建覆盖各级医疗机构的大健康服务体系，建设涵盖医疗服务、公共卫生服务、医疗保障、药品疫苗供应保障、卫生计生监管、健康管理等应用领域的“统一、开放、智慧、安全”的健康医疗大数据存储与安全中心（简称：大数据中心），保障信息互通互联，数据安全存储和服务协同应用',
    },
    {
      isTitle: true,
      text: '数字监管',
    },
    {
      text:
        '是医疗机构综合监管平台，为政府、特别是卫生健康部门决策和监管服务；',
    },
    {
      text: '是医疗机构能力提升平台，为医院提升管理和医疗水平服务；',
    },
    {
      isTitle: true,
      text: '智慧健康服务',
    },
    {
      text: '以居民电子健康卡为服务入口，把便民、惠民的健康医疗服务通过“互联网',
    },
    {
      text:
        '通过“互联网+/大数据+”探索医疗精准扶贫和实时远程协同服务，做到医疗扶贫扶真贫、真扶贫；',
    },
    {
      text: '形成政府监管、上下联动、资源合理配置的一体化智慧健康服务网络',
    },
    {
      isTitle: true,
      text: '标准研究',
    },
    {
      text:
        '成立健康医疗大数据应用标准研究院，以国家、国标标准化蓝本为基础，探索符合现代化业务发展趋势的统一标准，如：业务流程服务规范、数据存储与共享服务标准、信息安全与管理规范等',
    },
  ],
};

const product6 = {
  title: '刷脸就医',
  img: 'https://img.alicdn.com/tfs/TB1g6B7yKL2gK0jSZPhXXahvXXa-658-438.jpg',
  // path: '/service?post=1',
  icon: 'https://gw.alicdn.com/tfs/TB1QHtENVYqK1RjSZLeXXbXppXa-74-74.png',
  class: 'icon-hospital',
  tab: 'his',
  desc:
    '基于蚂蚁金服金融级人脸识别能力，可对全量人群进行身份核实。只凭刷脸，即可实现诊前、诊中、诊后的无障碍全流程便捷就医。',
  content: [
    {
      img: 'https://img.alicdn.com/tfs/TB1H6JUJkvoK1RjSZFwXXciCFXa-548-378.png',
    },
    {
      isTitle: true,
      text: '一、平台简介',
    },
    {
      text:
        '互联网医院平台是集监管与服务为一体的互联网诊疗服务的总入口，由服务子平台和监管子平台两个子平台构成。',
    },
    {
      img:
        'https://img.alicdn.com/tfs/TB1NYU9OZfpK1RjSZFOXXa6nFXa-1110-552.png',
    },
    {
      isTitle: true,
      text: '（1）服务子平台',
    },
    {
      text:
        '服务子平台以患者为中心，建立与机构协作，资源共享，互动沟通机制，形成互联网医院服务的统一入口。',
    },
    {
      text:
        '实体医疗机构获得互联网医院准入许可后，通过服务平台向患者提供部分常见病、慢性病服务、开具处方，帮助患者提升就诊便捷度，帮助医疗机构优化门诊效率。入驻医疗机构可不断深化服务，与院内检查、检验等诊疗服务互通共享，便捷开展预约诊疗、双向转诊、远程医疗等服务，构建覆盖诊前、诊中、诊后的线上线下一体化医疗服务模式。',
    },
    {
      isTitle: true,
      text: '（2）监管子平台',
    },
    {
      text:
        '监管子平台通过数据接入对所有提供互联网诊疗服务的医疗机构进行实时监管，包括事前监管（医疗机构、诊疗科目、医生监管，药品库、诊断库标准规范），事中监管（业务监管、违规监管、警告监管）以及事后监管（患者评价、申诉），保障医疗质量，规避医疗风险。',
    },
    {
      isTitle: true,
      text: '二、服务与功能',
    },
    {
      text:
        '目前，浙江省互联网医院平台患者端入口设在支付宝。用户打开支付宝APP，搜索“浙江省互联网医院平台”进入即可使用在线咨询等服务。慢病患者可获取慢病处方，足不出户接受配送到家的慢病药品，或可到医院、附近药店提取药品。',
    },
    {
      text:
        '医生可下载登录浙里医生APP，即可在线提供回复患者咨询、慢性病管理、开具处方等服务。',
    },
    {
      isTitle: true,
      text: '三、应用下载',
    },
    {
      isLink: true,
      url: [
        {
          icon:
            'https://gw.alicdn.com/tfs/TB10xAqXUz1gK0jSZLeXXb9kVXa-148-148.png',
          link:
            'https://apps.apple.com/cn/app/%E6%B5%99%E9%87%8C%E5%8C%BB%E7%94%9F/id1453831038',
          title: 'iOS',
          desc: '浙里医生 iOS 版本下载',
        },
        {
          icon:
            'https://gw.alicdn.com/tfs/TB1wNknXFY7gK0jSZKzXXaikpXa-148-148.png',
          link: 'http://www.zjjgpt.com/download/ngr_main-zlys-release.apk',
          title: 'Android',
          desc: '浙里医生 Android 版本下载',
        },
      ],
    },
  ],
};

export const serviceData = {
  title: '解决方案',
  subtitle: 'solution',
  path: '/solution',
  products: [product1, product2, product3, product4, product5, product6],
  productsPage: [
    {
      title: '互联网医院平台',
      img: 'https://img.alicdn.com/tfs/TB1H6JUJkvoK1RjSZFwXXciCFXa-548-378.png',
      path: '/service?post=1',
      icon: 'https://gw.alicdn.com/tfs/TB1QHtENVYqK1RjSZLeXXbXppXa-74-74.png',
      class: 'icon-hospital',
      tab: 'his',
      desc:
        '为患者提供在线咨询、慢病管理、家庭医师网上签约等服务，实现了”服务+管理“一体化。',
      content: [
        {
          img:
            'https://img.alicdn.com/tfs/TB1H6JUJkvoK1RjSZFwXXciCFXa-548-378.png',
        },
        {
          isTitle: true,
          text: '一、平台简介',
        },
        {
          text:
            '互联网医院平台是集监管与服务为一体的互联网诊疗服务的总入口，由服务子平台和监管子平台两个子平台构成。',
        },
        {
          img:
            'https://img.alicdn.com/tfs/TB1NYU9OZfpK1RjSZFOXXa6nFXa-1110-552.png',
        },
        {
          isTitle: true,
          text: '（1）服务子平台',
        },
        {
          text:
            '服务子平台以患者为中心，建立与机构协作，资源共享，互动沟通机制，形成互联网医院服务的统一入口。',
        },
        {
          text:
            '实体医疗机构获得互联网医院准入许可后，通过服务平台向患者提供部分常见病、慢性病服务、开具处方，帮助患者提升就诊便捷度，帮助医疗机构优化门诊效率。入驻医疗机构可不断深化服务，与院内检查、检验等诊疗服务互通共享，便捷开展预约诊疗、双向转诊、远程医疗等服务，构建覆盖诊前、诊中、诊后的线上线下一体化医疗服务模式。',
        },
        {
          isTitle: true,
          text: '（2）监管子平台',
        },
        {
          text:
            '监管子平台通过数据接入对所有提供互联网诊疗服务的医疗机构进行实时监管，包括事前监管（医疗机构、诊疗科目、医生监管，药品库、诊断库标准规范），事中监管（业务监管、违规监管、警告监管）以及事后监管（患者评价、申诉），保障医疗质量，规避医疗风险。',
        },
        {
          isTitle: true,
          text: '二、服务与功能',
        },
        {
          text:
            '目前，浙江省互联网医院平台患者端入口设在支付宝。用户打开支付宝APP，搜索“浙江省互联网医院平台”进入即可使用在线咨询等服务。慢病患者可获取慢病处方，足不出户接受配送到家的慢病药品，或可到医院、附近药店提取药品。',
        },
        {
          text:
            '医生可下载登录浙里医生APP，即可在线提供回复患者咨询、慢性病管理、开具处方等服务。',
        },
        {
          isTitle: true,
          text: '三、应用下载',
        },
        {
          isLink: true,
          url: [
            {
              icon:
                'https://gw.alicdn.com/tfs/TB10xAqXUz1gK0jSZLeXXb9kVXa-148-148.png',
              link:
                'https://apps.apple.com/cn/app/%E6%B5%99%E9%87%8C%E5%8C%BB%E7%94%9F/id1453831038',
              title: 'iOS',
              desc: '浙里医生 iOS 版本下载',
            },
            {
              icon:
                'https://gw.alicdn.com/tfs/TB1wNknXFY7gK0jSZKzXXaikpXa-148-148.png',
              link: 'http://www.zjjgpt.com/download/ngr_main-zlys-release.apk',
              title: 'Android',
              desc: '浙里医生 Android 版本下载',
            },
          ],
        },
      ],
    },
    {
      title: '大数据平台建设',
      img: 'https://img.alicdn.com/tfs/TB1MS0LJbvpK1RjSZFqXXcXUVXa-548-378.png',
      path: '/service?post=2',
      icon: 'https://gw.alicdn.com/tfs/TB100RON4jaK1RjSZFAXXbdLFXa-72-62.png',
      class: 'icon-data',
      tab: 'data',
      desc:
        '一个科技领先的大数据监管和应用平台，支持健康医疗服务水平的快速提升。',
      content: [
        {
          img:
            'https://img.alicdn.com/tfs/TB1MS0LJbvpK1RjSZFqXXcXUVXa-548-378.png',
        },
        {
          isTitle: true,
          text: '大数据存储与安全',
        },
        {
          text:
            '构建覆盖各级医疗机构的大健康服务体系，建设涵盖医疗服务、公共卫生服务、医疗保障、药品疫苗供应保障、卫生计生监管、健康管理等应用领域的“统一、开放、智慧、安全”的健康医疗大数据存储与安全中心（简称：大数据中心），保障信息互通互联，数据安全存储和服务协同应用',
        },
        {
          isTitle: true,
          text: '数字监管',
        },
        {
          text:
            '是医疗机构综合监管平台，为政府、特别是卫生健康部门决策和监管服务；',
        },
        {
          text: '是医疗机构能力提升平台，为医院提升管理和医疗水平服务；',
        },
        {
          isTitle: true,
          text: '智慧健康服务',
        },
        {
          text:
            '以居民电子健康卡为服务入口，把便民、惠民的健康医疗服务通过“互联网',
        },
        {
          text:
            '通过“互联网+/大数据+”探索医疗精准扶贫和实时远程协同服务，做到医疗扶贫扶真贫、真扶贫；',
        },
        {
          text: '形成政府监管、上下联动、资源合理配置的一体化智慧健康服务网络',
        },
        {
          isTitle: true,
          text: '标准研究',
        },
        {
          text:
            '成立健康医疗大数据应用标准研究院，以国家、国标标准化蓝本为基础，探索符合现代化业务发展趋势的统一标准，如：业务流程服务规范、数据存储与共享服务标准、信息安全与管理规范等',
        },
      ],
    },
    {
      title: '电子健康卡',
      img: 'https://img.alicdn.com/tfs/TB1UpRcKkvoK1RjSZPfXXXPKFXa-548-378.png',
      path: '/service?post=3',
      icon: 'https://gw.alicdn.com/tfs/TB1gy8vN6DpK1RjSZFrXXa78VXa-76-58.png',
      class: 'icon-ecard',
      tab: 'card',
      desc:
        '扫码即可就医，提升患者就医服务，实现跨机构和跨地域的线上线下一体化医疗健康服务。',
      content: [
        {
          img:
            'https://img.alicdn.com/tfs/TB1UpRcKkvoK1RjSZPfXXXPKFXa-548-378.png',
        },
        {
          text:
            '居民健康卡是国家卫生健康委员会统一规划实施的统一标准的“就诊卡”，可实现居民全程健康管理，提升居民健康的统一服务水平。当前智能卡应用正处在从“线下实体”向“线上虚拟”加速转型过程中，推进安全、可信的电子健康卡应用建设，实现线上线下一体化的身份认证服务，对于促进服务流程优化，保障线上应用安全，降低发卡用卡成本，实现居民健康卡应用广泛覆盖等具有十分重要的意义。',
        },
        {
          text:
            '电子健康卡具备就诊卡的所有功能。患者通过展示二维码给收费窗口、自助机、诊间、药房窗口和检验窗口来实现就诊全流程。与传统就诊卡相比，电子健康卡更方便用户携带(只需要携带手机即可)、安全性更高(动态二维码)、操作更方便。',
        },
      ],
    },
    {
      title: '刷脸就医',
      img: 'https://img.alicdn.com/tfs/TB1k1yzJY2pK1RjSZFsXXaNlXXa-548-378.png',
      path: '/service?post=4',
      icon: 'https://gw.alicdn.com/tfs/TB1D0xFNVzqK1RjSZFoXXbfcXXa-66-66.png',
      class: 'icon-face',
      tab: 'face',
      desc:
        '通过实名认证，利用人脸识别技术实现检查检验、住院登记、医保支付、报告读取等全程刷脸就医。',
      content: [
        {
          img:
            'https://img.alicdn.com/tfs/TB1k1yzJY2pK1RjSZFsXXaNlXXa-548-378.png',
        },
        {
          isTitle: true,
          text: '全流程的覆盖',
        },
        {
          text:
            '即通过“刷脸”在就医各个环节实现身份查验并完成支付，目的是让患者“更安全”、“更快捷”。在就医过程中，很多环节必须患者本人参与，“刷脸就医”结合了支付宝实名核身功能，确保患者就医安全。',
        },
        {
          isTitle: true,
          text: '全人群的普及',
        },
        {
          text:
            '就是指医保病人和自费病人这两类对象皆可享受。其中，医保病人的刷脸就医已面向杭州全市市级医保参保人群，而自费病人只要实名制开通支付宝，并在公安系统里有近期可识别的照片信息，即可体验。',
        },
        {
          isTitle: true,
          text: '看病更方便',
        },
        {
          text:
            '今后，就诊患者不再需要从包里取身份证、银行卡等，甚至连手机也不必使用，即使是抱着孩子的家长也可以单手完成操作。刷脸就医带来的技术升级，能有效缩短患者的等候时间，为缓解患者焦虑情绪、疏导院内交通带来便捷。',
        },
        {
          isTitle: true,
          text: '刷脸更安全',
        },
        {
          text:
            '采用的是生物识别技术，该技术使用定制3D摄像头，金融级算法以及行业通用的人脸识别库进行刷脸识别，具有全球独有眼纹和活体技术，可拦截各种伪造攻击，具有高准确性、高安全性和高稳定性，准确率和安全率可达99.99%以上。',
        },
      ],
    },
  ],
};
